import { Dialog, Transition } from '@headlessui/react';
import axios from 'axios';
import {
  Dispatch,
  Fragment,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { useDropzone } from 'react-dropzone';
import { useMutation } from 'react-query';
// import 'slick-carousel/slick/slick-theme.css';
// import 'slick-carousel/slick/slick.css';
import {
  useAccountHasPlanPaid,
  useAccountHasStarterPlan,
  useAccountHasTrialPlanPaid,
  useExpandFileUpload,
  useFileSelected,
  useFileUploadIsCSV,
  useForceCloseUploading,
  useProjectsNumber,
  useRequestConnectorsSent,
  useSheetName,
  useSheetsName,
  useSheetsScreenDone,
  useShowsSheetsScreen,
  useShowStepsUploading
} from '../../../lib/store/dashboard.store';
import {
  useAddToGroupList,
  useCancelModalUnsaveChanges,
  useConfirmModal,
  useFileAttached,
  useFileUploadedState,
  useMakeChangesSegments,
  usePageSelected,
  useRowSelected,
  useRowSelectedChanges,
  useSentLoader,
  useShowModalByWrongGroup,
  useStoreAllGridChanges,
  useStoreGroupedViews
} from '../../../lib/store/settings.store';
import { Projects } from '../../../models/projects';
import {
  getArryNumbersAtString,
  getLocalStorage,
  getMapProjects,
  getValuesFromArryNumbersAtString,
  getWorkspace,
  isSafari,
  sanitizeGoogleSheetURL,
  setLocalStorage,
  splitFileName,
  uploadFile
} from '../../../utils';
import { Echart } from '../../Echart';
import { Button } from '../button';
import { Loader } from '../loader';

import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { useAuth } from '../../../../../scripts/fb';
// import { CarouselUI } from '../carousel';
import { Connector } from './connector';
import './styles.css';
import { UpgradePlanText } from '../../Layout/app/frame/shared/upgrade-text';
import {
  useCollectionAlreadyExists,
  useColletionsSelected,
  useGoingToFromMyViews,
  useisDeleteViewSelected,
  useisSharedViewSelected,
  useShowFileUpdated,
  useShowFileUpdatedGranted,
  useStoreCollectionPreSelected
} from '../../../lib/store/my-view.store';
import { baseurl } from '../../../constant';
import {
  useAccountHasLillyPaid,
  useEmailsShared,
  useShowShareModalLoader
} from '../../../lib/store/frame.store';
import { UploadStepsSpinningWheel } from '../steps-spinning-wheel/upload';
import * as XLSX from 'xlsx';
import connectorsData from './connectors.json';
import { Userpilot } from 'userpilot';
import JSZip from 'jszip';
import { useNewLillyClaim, useProjectNumbers } from '../../../lib/store/v3/layout';
import { LoaderBubble } from '../../Layout/app/frame/shared/loader-bubble';
import { SentryReportError } from '../../../../utils';
import { useLocation } from 'react-router-dom';

export const Modal = ({
  openModal,
  setOpenModal,
  type,
  title,
  setFileDeleted,
  setUnSaveChangesModal,
  setConfirm,
  setCancel,
  setRowsAgGrid,
  filesToDelete,
  isFileUploaded,
  setIsFileUploaded,
  setHeaderRows,
  headerRows,
  setIsUploadingData,
  isUploadingData,
  optionChart,
  setTypeModal,
  selectedFile,
  setSelectedFile,
  setShareUpdated,
  showUpgradePlan,
  setShowUpgradePlan,
  from,
  setOption,
  grid,
  setType,
  handleClickUpgrade,
  rowsAgGrid
}: {
  openModal: boolean;
  setOpenModal?: Dispatch<SetStateAction<boolean>>;
  type?: string;
  title?: string;
  setFileDeleted?: Dispatch<SetStateAction<boolean>>;
  setUnSaveChangesModal?: Dispatch<SetStateAction<boolean>>;
  setConfirm?: Dispatch<SetStateAction<boolean>>;
  setCancel?: Dispatch<SetStateAction<boolean>>;
  setRowsAgGrid?: Dispatch<SetStateAction<Projects[]>>;
  filesToDelete?: Array<string>;
  isFileUploaded?: any;
  setIsFileUploaded?: any;
  setHeaderRows?: any;
  headerRows?: number;
  setIsUploadingData?: any;
  isUploadingData?: any;
  optionChart?: any;
  setTypeModal?: Dispatch<SetStateAction<string>>;
  selectedFile?: any;
  setSelectedFile?: any;
  setShareUpdated?: Dispatch<SetStateAction<boolean>>;
  showUpgradePlan?: boolean;
  setShowUpgradePlan?: Dispatch<SetStateAction<boolean>>;
  from?: string;
  setOption?: any;
  grid?: any;
  setType?: any;
  handleClickUpgrade?: any;
  rowsAgGrid?: any;
}) => {
  const location = useLocation().pathname;
  const cancelButtonRef = useRef(null);
  const uploadInputRef = useRef(null);
  const [fileUploaded, setFileUploaded] = useState<any>(null);
  const [fileName, setFileName] = useState<string>('');
  const [deleteFile, setDeleteFile] = useState<boolean>(false);
  const [excelColumns, setExcelColumns] = useState<any>(null); // eslint-disable-line @typescript-eslint/no-unused-vars
  const [dataList, setDataList] = useState<any>(null); // eslint-disable-line @typescript-eslint/no-unused-vars
  const setConfirmClicked = useConfirmModal((state: any) => state.updateIsConfirmClicked);
  const setFileUploadedState = useFileUploadedState((state: any) => state.setFileUploadedState);
  const setFileAttached = useFileAttached((state: any) => state.setFileAttached);
  const fileJustAttached = useFileAttached((state: any) => state.file);
  const setIsCanceled = useCancelModalUnsaveChanges((state: any) => state.setIsCanceled);
  const gridChanges = useStoreAllGridChanges((state: any) => state.gridChanges);
  const groupedViews = useStoreGroupedViews((state: any) => state.groupedViews);
  const groupRollbackList = useAddToGroupList((state: any) => state.groupRollbackList);
  const setSentLoader = useSentLoader((state: any) => state.setSentLoader);
  const setShowModal = useShowModalByWrongGroup((state: any) => state.setShowModal);
  const [saveChangesOff, setSaveChangesOff] = useState<boolean>(true);
  const setNumProjects = useProjectNumbers((state: any) => state.setNumProjects);
  // const [showCrossIcon, setShowCrossIcon] = useState<any>({
  //   shown: false,
  //   email: null
  // });
  const [emails, setEmails] = useState<any[]>([]);
  const [email, setEmail] = useState<string>('');
  const fileSelected = useFileSelected((state: any) => state.fileSelected);
  const [showFileReq, setShowFileReq] = useState<boolean>(false);
  const [showTabUpload, setShowTabUpload] = useState<boolean>(true);
  const [fileAttachedToDelete, setFileAttachedToDelete] = useState<string>();
  const [enableReqConnection, setEnableReqConnection] = useState<boolean>(true);
  const sheets = useSheetsName((state: any) => state.names);
  const setSheets = useSheetsName((state: any) => state.setNames);
  const sheetSelected = useSheetName((state: any) => state.name);
  const setSheetSelected = useSheetName((state: any) => state.setName);
  const [uploadFileBtn, setUploadFileBtn] = useState<boolean>(false);
  const [googleSheetUrl, setGoogleSheetUrl] = useState<string>('');
  const expand = useExpandFileUpload((state: any) => state.expand);
  const setExpand = useExpandFileUpload((state: any) => state.setExpand);
  const setShowSteps = useShowStepsUploading((state: any) => state.setShowSteps);
  const [standartConnectors, setStandartConnectors] = useState<any[]>([
    {
      icon: 'bigquery',
      name: 'BigQuery',
      selected: false
    },
    {
      icon: 'salesforce',
      name: 'SalesForce',
      selected: false
    },
    {
      icon: 'surveymonkey',
      name: 'SurveyMonkey',
      selected: false
    },
    {
      icon: 'powerbi',
      name: 'PowerBI',
      selected: false
    },
    {
      icon: 'airtable',
      name: 'Airtable',
      selected: false
    },
    {
      icon: 'athena',
      name: 'Athena',
      selected: false
    },
    {
      icon: 'azuretable',
      name: 'Azure Table',
      selected: false
    },
    {
      icon: 'datadog',
      name: 'Datadog',
      selected: false
    },
    {
      icon: 'dayforce',
      name: 'Dayforce',
      selected: false
    },
    {
      icon: 'dynamodb',
      name: 'DynamoDB',
      selected: false
    },
    {
      icon: 'facebook',
      name: 'Facebook Ads',
      selected: false
    },
    {
      icon: 'google-sheet',
      name: 'Google Sheets',
      selected: false
    },
    {
      icon: 'hubspot',
      name: 'Hubspot',
      selected: false
    },
    {
      icon: 'looker',
      name: 'Looker',
      selected: false
    },
    {
      icon: 'mailchimp',
      name: 'Mailchimp',
      selected: false
    },
    {
      icon: 'marketo',
      name: 'Marketo',
      selected: false
    },
    {
      icon: 'metabase',
      name: 'Metabase',
      selected: false
    },
    {
      icon: 'microsoftteams',
      name: 'Microsoft Teams',
      selected: false
    },
    {
      icon: 'mongo',
      name: 'MongoDB',
      selected: false
    },
    {
      icon: 'mysql',
      name: 'MySQL',
      selected: false
    },
    {
      icon: 'notion',
      name: 'Notion',
      selected: false
    },
    {
      icon: 'oracle',
      name: 'ORACLE Database',
      selected: false
    },
    {
      icon: 'plaid',
      name: 'Plaid',
      selected: false
    },
    {
      icon: 'postgress',
      name: 'Postgres',
      selected: false
    },
    {
      icon: 'sendgrid',
      name: 'SendGrid',
      selected: false
    },

    {
      icon: 'shopify',
      name: 'Shopify',
      selected: false
    },
    {
      icon: 'snowflake',
      name: 'Snowflake',
      selected: false
    },
    {
      icon: 'tableau',
      name: 'Tableau',
      selected: false
    },
    {
      icon: 'typeform',
      name: 'Typeform',
      selected: false
    }

    // {
    //   icon: 'github',
    //   name: 'GitHub',
    //   selected: false
    // },

    // {
    //   icon: 'eloqua',
    //   name: 'Eloqua',
    //   selected: false
    // },

    // {
    //   icon: 'liveperson',
    //   name: 'LivePerson',
    //   selected: false
    // },

    // {
    //   icon: 'mixpanel',
    //   name: 'Mixpanel',
    //   selected: false
    // },

    // {
    //   icon: 'salesforcemarketing',
    //   name: 'SalesForce Marketing Cloud',
    //   selected: false
    // },

    // {
    //   icon: 'twilio',
    //   name: 'Twilio',
    //   selected: false
    // },

    // {
    //   icon: 'zoho',
    //   name: 'Zoho CRM',
    //   selected: false
    // }
  ]);
  const [connectorUpdated, setConnectorUpdated] = useState<boolean>(false);
  const setSentRequest = useRequestConnectorsSent((state: any) => state.setSentRequest);
  const setRowSelected = useRowSelected((state: any) => state.updateRowSelected);
  const setChangedSegments = useMakeChangesSegments((state: any) => state.setChanged);
  const setRowChanged = useRowSelectedChanges((state: any) => state.setChanged);
  const auth = useAuth();
  const [skipHeaders, setSkipHeaders] = useState<boolean>(false);
  const isSafariBrowser = isSafari();
  const [checksReadyUpload, setChecksReadyUpload] = useState<boolean>(false);
  const accountPaid = useAccountHasPlanPaid((state: any) => state.accountPaid);
  const newLillyClaim = useNewLillyClaim((state: any) => state.newLillyClaim);
  const trialAccountPaid = useAccountHasTrialPlanPaid((state: any) => state.trialAccountPaid);
  const accountLillyPaid = useAccountHasLillyPaid((state: any) => state.accountPaid);
  const starterAccount = useAccountHasStarterPlan((state: any) => state.accountPaid);
  const setDeleteFromMyViewPage = useisDeleteViewSelected((state: any) => state.setDelete);
  const setShareFromMyViewPage = useisSharedViewSelected((state: any) => state.setShare);
  const [isDeletingView, setIsDeletingView] = useState<boolean>(false);
  const collectionsMyViews = useColletionsSelected((state: any) => state.collections);
  const [emailsSharedCollection, setEmailsSharedCollection] = useState<any>([]);
  const setShowFileUpdated = useShowFileUpdated((state: any) => state.setShow);
  const setShowFileUpdatedGranted = useShowFileUpdatedGranted((state: any) => state.setShow);
  const dataPreSelectedMyViews = useStoreCollectionPreSelected((state: any) => state.data);
  const setGoingPage = useGoingToFromMyViews((state: any) => state.setGoing);
  const setPage = usePageSelected((state: any) => state.updatePage);
  const emailsShared = useEmailsShared((state: any) => state.emails);
  const showSheetsScreen = useShowsSheetsScreen((state: any) => state.show);
  const setShowSheetsScreen = useShowsSheetsScreen((state: any) => state.setShow);
  const setDoneSheetsScreen = useSheetsScreenDone((state: any) => state.setDone);
  const doneSheetsScreen = useSheetsScreenDone((state: any) => state.done);
  const setIsCSVFile = useFileUploadIsCSV((state: any) => state.setIsCSV);
  const isCSVFile = useFileUploadIsCSV((state: any) => state.isCSV);
  const [inputTextConnector, setInputTextConnector] = useState<string>('');

  const setForceCloseUpload = useForceCloseUploading((state: any) => state.setForce);
  const forceCloseUpload = useForceCloseUploading((state: any) => state.force);
  const [connectorSearch, setConnectorSearch] = useState<string>('');
  const [showConnectorDropDown, setShowConnectorDropDown] = useState<boolean>(false);
  const [connectorsFiltered, setConnectorsFiltered] = useState<any>();
  const [connectorsList, setConnectorsList] = useState<any>([]);
  const [notificationChecked, setNotificationChecked] = useState<boolean>(true);
  const shareFileLoader = useShowShareModalLoader((state: any) => state.shareFileLoader);
  const setShareFileLoader = useShowShareModalLoader((state: any) => state.setShareFileLoader);
  // const [shareFileLoader, setShareFileLoader] = useState<boolean>(false);

  useEffect(() => {
    if (emailsShared && emailsShared.length > 0) {
      setEmails(emailsShared);
      setEmailsSharedCollection(emailsShared);
    } else if (from === 'myviews') {
      setEmails([]);
      setEmailsSharedCollection([]);
    }
  }, [emailsShared]);

  // useEffect(() => {
  //   if (from === 'myviews') {
  //     setEmails([]);
  //     setEmailsSharedCollection([]);
  //   }
  // }, [collectionsMyViews]);

  useEffect(() => {
    if (openModal) {
      setChecksReadyUpload(false);
    }
  }, [openModal]);

  const createWorkspace = (link: string) => {
    uploadFile(
      link,
      fileUploaded,
      async () => {
        setFileUploadedState(true);
        setFileAttachedToDelete(undefined);
        setFileName('');
        setGoogleSheetUrl('');
      },
      () => {
        setIsUploadingData(false);
        setIsFileUploaded(true);
        setFileUploadedState(false);
        setFileName('');
        setGoogleSheetUrl('');
      }
    );
  };

  const cleanStatusOfFileDeletion = (payload) => {
    setDeleteFile(false);
    if (!payload?.closeIcon) setFileDeleted && setFileDeleted(true);
    setOpenModal && setOpenModal(false);
    if (!payload?.closeIcon) {
      setTimeout(() => {
        setFileDeleted && setFileDeleted(false);
      }, 700);
    }
  };

  const deleteCollectionItem = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    const route = `${baseurl}/collection/${payload.view}/item/properties`;
    try {
      await axios.delete(route, {
        params: {},
        headers: {
          Authorization: token
        }
      });
      cleanStatusOfFileDeletion(payload);
    } catch (error: any) {
      cleanStatusOfFileDeletion(payload);
      SentryReportError(error, {
        payload: payload || null
      });
      if (error?.response?.status == 403 || error?.response?.status == 401) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
    }
  });

  const deleteCollection = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    const route = `${baseurl}/collection/${payload.view}`;
    try {
      const response = await axios.delete(route, {
        params: {},
        headers: {
          Authorization: token
        }
      });
      if (response && response.data && response.status == 200) {
        const payloadCollectionItem = {
          view: payload.view
        };
        deleteCollectionItem.mutate(payloadCollectionItem);
      }
    } catch (error: any) {
      cleanStatusOfFileDeletion(payload);
      SentryReportError(error, {
        payload: payload || null
      });
      if (error?.response?.status == 403 || error?.response?.status == 401) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
    }
  });

  const getCollections = async (payload) => {
    try {
      const token = await auth.user?.getIdToken();
      if (!token) return;
      const route = `${baseurl}/collections`;
      const response = await axios.get(route, {
        headers: {
          Authorization: token,
          'Cache-Control': 'no-store'
        }
      });
      if (response && response.status === 200) {
        const collections = response?.data?.result;
        const filterByFile = collections?.filter((r) => r.file === payload?.payload?.file) || [];
        if (filterByFile && filterByFile.length > 0) {
          filterByFile.forEach((item) => {
            const payloadCollections = {
              ...payload,
              view: item.collection
            };
            deleteCollection.mutate(payloadCollections);
          });
        } else {
          cleanStatusOfFileDeletion(payload);
        }
      }
    } catch (error: any) {
      cleanStatusOfFileDeletion(payload);
      SentryReportError(error, {
        payload: null
      });
      if (
        error?.response?.status == 403 ||
        error?.message === 'auth.user?.getIdToken is not a function' ||
        error?.response?.status == 401
      ) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
    }
  };

  const deleteProject = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    try {
      const response = await axios.delete(`/project/${payload.file}`, {
        params: {
          workspace: payload.file
        },
        headers: {
          Authorization: token
        }
      });
      if (response && response.data && response.status == 200) {
        const rows = getMapProjects(response.data);
        setRowsAgGrid && setRowsAgGrid(rows);
        const projects = response?.data?.length;
        setLocalStorage('projects-number', projects);
        setNumProjects(projects);
        const checksFileDeleted = rowsAgGrid.find((r) => r.id === payload.file);
        if (checksFileDeleted?.ownerEmail == 'Me') {
          const payloadCollections = {
            payload
          };
          getCollections(payloadCollections);
        } else {
          cleanStatusOfFileDeletion(payload);
        }
      }
    } catch (error: any) {
      cleanStatusOfFileDeletion(payload);
      if (error?.response?.status == 403 || error?.response?.status == 401) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
    }
  });

  const updateNameProject = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    try {
      await axios.put(
        `/project/${payload.currentValue}`,
        {
          displayName: payload.newValue
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
    } catch (error: any) {
      if (error?.response?.status == 403 || error?.response?.status == 401) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
    }
  });

  const createProject = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    const route = `/project/${payload.workspaceid}`;
    try {
      const response = await axios.post(
        route,
        {},
        {
          headers: {
            Authorization: token
          }
        }
      );
      if (response && response.status === 200) {
        localStorage.removeItem('endUploadLoader');
        setFileAttached(response.data.Name);
        setLocalStorage('workspace-sheet', response.data.Name);
        setFileAttachedToDelete(response.data.Name);
        payload = {
          ...payload,
          workspaceid: response.data.Name
        };
        getUploadLink.mutate(payload);

        if (payload.blanks) {
          const updatePayload = {
            newValue: payload.originalFile,
            currentValue: payload.workspaceid
          };
          updateNameProject.mutate(updatePayload);
        }
      }
    } catch (error: any) {
      if (error?.response?.status == 403 || error?.response?.status == 401) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
      setIsUploadingData(false);
      setIsFileUploaded(true);
    }
  });

  const getUploadLink = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    let body;
    let reCallApi = false;
    if (payload.type.includes('xls')) {
      if (sheetSelected && sheetSelected.length > 0) {
        body = {
          filetype: payload.type,
          headers: payload.headers,
          sheet: sheetSelected
        };
      } else {
        reCallApi = true;
        setLocalStorage('payload-getUploadLink', payload);
      }
    } else {
      body = {
        filetype: payload.type,
        headers: payload.headers
      };
    }
    if (!reCallApi) {
      try {
        const response = await axios.put(`/project_upload_link/${payload.workspaceid}`, body, {
          headers: {
            Authorization: token
          }
        });
        if (response && response.data && response.status == 200) {
          createWorkspace(response.data);
        }
      } catch (error: any) {
        if (error?.response?.status == 403 || error?.response?.status == 401) {
          setLocalStorage('token', null);
          setLocalStorage('userData', null);
          window.open('/', '_self');
        }
        setIsUploadingData(false);
        setIsFileUploaded(true);
      }
    }
  });

  useEffect(() => {
    if (doneSheetsScreen) {
      const payload = getLocalStorage('payload-getUploadLink');
      if (payload && googleSheetUrl?.length == 0) {
        getUploadLink.mutate(payload);
        localStorage.removeItem('workspace-sheet');
        localStorage.removeItem('payload-getUploadLink');
      } else if (googleSheetUrl?.length > 0) {
        uploadGoogleSheet();
      }
      setDoneSheetsScreen(false);
      setShowSheetsScreen(false);
    }
  }, [doneSheetsScreen]);

  const onDrop = useCallback((acceptedFiles: any) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const name = acceptedFiles[0].path ?? acceptedFiles[0].name;
      setFileUploaded(acceptedFiles[0]);
      setFileName(name);
      setIsFileUploaded(true);
      const reader = new FileReader();
      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');
      reader.onload = (event: any) => {
        const arrayBuffer = event.target.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        const names = workbook.SheetNames;
        if (names.length == 1) {
          setSheetSelected(names[0]);
        } else {
          setSheetSelected('');
          setSheets(names);
          setShowSheetsScreen(true);
        }
      };
      reader.readAsArrayBuffer(acceptedFiles[0]);
      handleUploadFile(name);
    }
  }, []);

  const { getRootProps } = useDropzone({
    onDrop,
    accept: {
      'file/xlsx': [
        '.xlsx',
        '.csv',
        // '.xls',
        // '.mat',
        '.sav'
        // '.parquet',
        // '.sas7bdat',
        // '.xport',
        // '.dta',
        // '.csv.gz',
        // '.csv.gzip',
        // '.gz',
        // '.json'
      ]
    },
    // accept: ['.jpg', '.jpeg', '.png', '.pdf']
    maxFiles: 1
  });

  useEffect(() => {
    const { extension } = splitFileName(fileName);
    if (
      fileName &&
      extension !== 'csv' &&
      extension !== 'xls' &&
      extension !== 'xlsx' &&
      extension !== 'gz' &&
      extension !== 'sav'
    ) {
      handleUploadFile();
    }
  }, [fileName]);

  const handleUploadFile = (file?: string) => {
    const fileDesc: string = (fileName && fileName?.length > 0 ? fileName : file) || '';
    const { name, extension } = splitFileName(fileDesc);
    let isGzFile = false;
    if (name.includes('.csv') && extension === 'gz') isGzFile = true;
    let payload = {};
    if (name.includes(' ')) {
      payload = {
        workspaceid: !isGzFile
          ? name.replace(/ /g, '_')
          : name.replace(/ /g, '_').replace('.csv', ''),
        type: extension,
        headers: 1,
        blanks: true,
        originalFile: name
      };
    } else {
      payload = {
        workspaceid: !isGzFile ? name : name.replace('.csv', ''),
        type: extension,
        headers: 1,
        blanks: false
      };
    }
    setIsUploadingData(true);
    if (extension.includes('csv') || extension.includes('sav')) setIsCSVFile(true);
    else setIsCSVFile(false);
    // setSheetSelected('');
    setLocalStorage('extension-file', extension);
    Userpilot.track('add_data_file_upload');
    createProject?.mutate(payload);

    localStorage.removeItem('drop-test');
  };

  const handleDeletion = async () => {
    if (from === 'myviews') {
      setDeleteFromMyViewPage(true);
      setIsDeletingView(true);
      setTimeout(() => {
        setIsDeletingView(false);
      }, 5000);
    } else {
      if (filesToDelete && filesToDelete?.length > 0) {
        setDeleteFile(true);
        filesToDelete?.forEach((file) => {
          const payload = {
            file: file
          };
          deleteProject.mutate(payload);
        });
      }
    }
  };

  const hasRollbackSettings = () => {
    return (
      (gridChanges?.length > 0 ||
        groupedViews?.length > 0 ||
        (groupRollbackList && Object.entries(groupRollbackList)?.length > 0)) ??
      false
    );
  };

  const closeIcon = () => {
    const hasRollBack = hasRollbackSettings();
    if (type === 'unsavechanges') {
      setUnSaveChangesModal && setUnSaveChangesModal(false);
      if (!hasRollBack) setCancel && setCancel(true);
      setRowSelected(null);
      setChangedSegments(false);
      setRowChanged(false);
      setIsCanceled(true);
      if (hasRollBack) setSentLoader(true);
    } else if (type === 'excludeGroup') {
      setShowModal(false);
    } else {
      setOpenModal && setOpenModal(false);
      setFileDeleted && setFileDeleted(false);
    }
    if (from === 'myviews') {
      setShareFileLoader(false);
      grid?.api?.forEachNode((node: any) => node.setSelected(false));
      setOption(0);
    }
    if (type === 'share-file') {
      setShareFileLoader(false);
      setEmails([]);
      setSaveChangesOff(true);
      setEmail('');
      setTypeModal && setTypeModal('');
      setSelectedFile && setSelectedFile(null);
    }
    if (setType) setType('');
  };

  const handleConfirm = () => {
    setConfirm && setConfirm(true);
    setConfirmClicked(true);
  };

  const handleChooseFile = () => {
    if (!(uploadInputRef?.current as any)?.value) {
      uploadInputRef?.current && (uploadInputRef?.current as any)?.click();
    }
  };

  const handleUploadFileClick = () => {
    const file: any = uploadInputRef.current;
    if (file) {
      setFileUploaded(file?.files[0]);
      const reader = new FileReader();
      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');
      reader.onload = (event: any) => {
        const arrayBuffer = event.target.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        const names = workbook.SheetNames;
        if (names.length == 1) {
          setSheetSelected(names[0]);
        } else {
          setSheetSelected('');
          setSheets(names);
          setShowSheetsScreen(true);
        }
      };
      reader.readAsArrayBuffer(file?.files[0]);

      const fileName = file?.value.split('\\')[2];
      const { extension } = splitFileName(fileName);
      setFileName(file?.value.split('\\')[2]);
      setIsFileUploaded(true);
      handleUploadFile(file?.value.split('\\')[2]);
    }
  };

  useEffect(() => {
    if (forceCloseUpload) {
      setShowTabUpload(true);
      setForceCloseUpload(false);
    }
  }, [forceCloseUpload]);

  const closeIconFile = () => {
    setExpand(false);
    setShowSteps(false);
    setShowFileReq(false);
    // setUploadErrorMessage('');
    if (fileAttachedToDelete || fileJustAttached?.length > 0) {
      const payload = {
        file: fileAttachedToDelete || fileJustAttached,
        closeIcon: true
      };
      deleteProject.mutate(payload);
    }
    setOpenModal && setOpenModal(false);
    setTimeout(() => {
      setShowTabUpload(true);
    }, 300);
    setTimeout(() => {
      setIsFileUploaded(false);
    }, 1000);
    resetConnectors();
    setChecksReadyUpload(false);
    if (showUpgradePlan) {
      setShowUpgradePlan && setShowUpgradePlan(false);
      setIsUploadingData(false);
      setHeaderRows(1);
      setFileUploadedState(false);
    }
    setShowSheetsScreen(false);
    setTimeout(() => {
      localStorage.removeItem('endUploadLoader');
      setSheetSelected('');
    }, 1500);
  };

  const getEmails = (emailsSplit) => {
    const emailsArr: string[] = [];
    emailsSplit.forEach((element) => {
      if (element !== '') emailsArr.push(element);
    });
    const join = emails.concat(emailsArr);
    return join;
  };

  useEffect(() => {
    if (selectedFile) {
      setEmails(selectedFile.sharedEmails);
    }
  }, [selectedFile]);

  const addEmails = () => {
    const emailsSplit: any = email?.split(',').map((email) => email.trim());
    const result = getEmails(emailsSplit);
    if (result.length > 0) {
      setEmails(result);
      setSaveChangesOff(false);
    } else {
      setEmails([]);
      setSaveChangesOff(true);
    }
    setEmail('');
  };

  const handleRemoveSingleValue = (value: string) => {
    const emailsFiltered = emails.filter((email) => email !== value);
    setEmails(emailsFiltered);
    if (emailsFiltered.length === 0 && selectedFile?.sharedEmails?.length === 0) {
      setSaveChangesOff(true);
    } else setSaveChangesOff(false);
  };

  const shareProject = useMutation(async (fromMyViews: boolean) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    const workspaceid = fileSelected || getWorkspace(location);

    try {
      const response = await axios.put(
        `/share/${workspaceid}`,
        { emails: emails, send_notification_emails: notificationChecked },
        {
          headers: {
            Authorization: token
          }
        }
      );
      if (response && response.status == 200) {
        if (fromMyViews) {
          shareCollectionView();
        }
        setTimeout(() => {
          setShareFileLoader(false);
          setShareUpdated && setShareUpdated(true);
          setOpenModal && setOpenModal(false);
        }, 2000);
      }
    } catch (error: any) {
      if (fromMyViews) {
        shareCollectionView();
      } else {
        setShareFileLoader(false);
        if (error?.response?.status == 403 || error?.response?.status == 401) {
          setLocalStorage('token', null);
          setLocalStorage('userData', null);
          window.open('/', '_self');
        }
      }
    }
  });

  const shareCollectionView = () => {
    setShareFromMyViewPage({
      shared: true,
      emails: emails,
      data: collectionsMyViews[0]?.data
    });
  };

  const handleClickSaveChanges = () => {
    setShareFileLoader(true);
    shareProject?.mutate(from === 'myviews' ? true : false);
  };

  const handelCancel = () => {
    setShowFileReq(false);
  };

  const handleTabUpload = () => {
    setShowTabUpload(true);
  };

  const handleTabSource = () => {
    setShowTabUpload(false);
  };

  const submitConnectors = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    const route = `/message`;
    try {
      const response = await axios.post(
        route,
        {
          request: payload.connectors
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      if (response && response.status === 200) {
        setOpenModal && setOpenModal(false);
        resetConnectors();
        setShowTabUpload(true);
        setSentRequest(true);
      }
    } catch (error: any) {
      if (error?.response?.status == 403 || error?.response?.status == 401) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
    }
  });

  const resetConnectors = () => {
    standartConnectors.forEach((element) => {
      element.selected = false;
    });
    setEnableReqConnection(true);
    setConnectorUpdated(true);
  };

  const handleClickReqConnection = () => {
    const items: any[] = [];
    standartConnectors.forEach((element) => {
      if (element.selected) {
        items.push(element.name);
      }
    });

    if (connectorsList?.length > 0) {
      connectorsList.forEach((element) => {
        items.push(element);
      });
    }

    if (items && items.length > 0) {
      const payload = {
        connectors: items
      };
      submitConnectors.mutate(payload);
    }
  };

  const handleClickConnector = (connector) => {
    const selecteds = standartConnectors.filter((e) => e.selected)?.length ?? 0;
    const lenSelectorsSearch = connectorsList.length ?? 0;
    const cond1 =
      (selecteds < 3 || (connector.selected && selecteds == 3)) && lenSelectorsSearch == 0;
    const cond2 =
      (selecteds < 2 || (connector.selected && selecteds == 2)) && lenSelectorsSearch == 1;
    const cond3 =
      (selecteds < 1 || (connector.selected && selecteds == 1)) && lenSelectorsSearch == 2;
    if (cond1 || cond2 || cond3) {
      const connectorSelected = standartConnectors.find((e) => e.name === connector.name);
      connectorSelected.selected = !connector.selected;
      let enableBtn = true;
      standartConnectors.forEach((element) => {
        if (element.selected) {
          enableBtn = false;
        }
      });

      if (enableBtn && connectorsList.length > 0) {
        enableBtn = false;
      }

      setEnableReqConnection(enableBtn);
      setStandartConnectors(standartConnectors);
      setConnectorUpdated(true);
    }
  };

  useEffect(() => {
    if (connectorUpdated) {
      setConnectorUpdated(false);
    }
  }, [connectorUpdated]);

  const closeViewDisplay = () => {
    setTimeout(() => {
      setShowFileUpdated(false);
    }, 1000);
    closeIcon();
  };

  const closeViewDisplayFileChanges = () => {
    closeViewDisplay();
  };

  const handleGoAnyWay = () => {
    setShowFileUpdatedGranted(true);
    if (
      dataPreSelectedMyViews.app === 'reports' ||
      dataPreSelectedMyViews.app === 'correlation' ||
      dataPreSelectedMyViews.app === 'pivot'
    )
      setPage(dataPreSelectedMyViews.app);
    else if (dataPreSelectedMyViews.app === 'signals') setPage('clusters');
    else if (dataPreSelectedMyViews.app === 'cohorts') setPage('360');
    setGoingPage({
      go: true,
      data: dataPreSelectedMyViews.data
    });
    setLocalStorage('goingPageFromMyViews', true);
    setLocalStorage('goAnyWayFlag', true);
    closeViewDisplay();
  };

  const handleInputConnector = (e) => {
    const value = e.target.value;
    setConnectorSearch(value);
    setShowConnectorDropDown(value.length > 0);
    const matchingOptions = connectorsData.filter((connector) =>
      connector.toLowerCase().includes(value.toLowerCase())
    );
    setConnectorsFiltered(matchingOptions);
  };

  const getValidateConnectorText = () => {
    let exists = false;
    exists = !!standartConnectors.find((e) => e.name == connectorSearch);
    if (!exists) {
      exists = !!connectorsData.find((e) => e == connectorSearch);
    }
    return exists;
  };

  const addConnectorsToList = () => {
    if (getValidateConnectorText()) {
      const arr: any = [];
      const selecteds = standartConnectors.filter((e) => e.selected)?.length ?? 0;
      const cond1 = connectorsList.length < 3 && selecteds == 0;
      const cond2 = connectorsList.length < 2 && selecteds == 1;
      const cond3 = connectorsList.length < 1 && selecteds == 2;
      if (cond1 || cond2 || cond3) {
        arr.push(connectorSearch);
        const join = connectorsList.concat(arr);
        setConnectorsList(join);
        setConnectorSearch('');
        setEnableReqConnection(false);
        setShowConnectorDropDown(false);
      }
    }
  };

  const handleKeyDownConnector = (e) => {
    if (e.key === 'Enter') {
      addConnectorsToList();
    }
  };

  const handleRemoveConnector = (connector: string) => {
    const selecteds = standartConnectors.filter((e) => e.selected)?.length ?? 0;
    const filter = connectorsList.filter((e) => e !== connector);
    setConnectorsList(filter);
    if (filter.length == 0 && selecteds == 0) {
      setEnableReqConnection(true);
    }
  };

  const uploadGoogleSheet = () => {
    const fetchXLSX = async () => {
      try {
        const xlsxURL = sanitizeGoogleSheetURL(googleSheetUrl);
        const response = await fetch(xlsxURL);
        const arrayBuffer = await response.arrayBuffer();
        // const zip = await JSZip.loadAsync(arrayBuffer);
        // const chartPaths = Object.keys(zip.files).filter(path => path.startsWith('xl/charts/'));
        // if (chartPaths.length > 0) {
        //   console.log('Charts found:', chartPaths);
        // } else {
        //   console.log('No charts found in the sheet.');
        // }
        const workbook = XLSX.read(arrayBuffer, { type: 'array', cellDates: true });
        const sheetNames =
          sheetSelected && sheetSelected?.length > 0 ? [sheetSelected] : workbook.SheetNames;
        if (sheetNames && sheetNames.length > 1) {
          setSheetSelected('');
          setSheets(sheetNames);
          setShowSheetsScreen(true);
          setIsFileUploaded(true);
        } else {
          const desiredSheet = workbook.Sheets[sheetNames[0]];
          const data = XLSX.utils.sheet_to_json(desiredSheet, { header: 1 });
          const processedData = data.map((row: any) =>
            row.map((cell) => {
              if (typeof cell === 'string' && /^\$?[\d,]+(\.\d{2})?$/.test(cell)) {
                return parseFloat(cell.replace(/[^0-9.-]+/g, ''));
              }
              return cell;
            })
          );

          const csv = XLSX.utils.sheet_to_csv(XLSX.utils.aoa_to_sheet(processedData));
          const blob = new Blob([csv], { type: 'text/csv' });
          const name =
            sheetSelected?.length > 0
              ? `Google Sheets ${sheetSelected}.csv`
              : 'Imported from Google Sheets.csv';
          const file = new File([blob], name, { type: 'text/csv' });
          onDrop([file]);
        }
      } catch (error) {
        console.error('Error fetching the XLSX file:', error);
      }
    };

    fetchXLSX();
  };

  const handleUploadGoogleSheet = () => {
    Userpilot.track('add_data_googlesheets');
    uploadGoogleSheet();
  };

  return (
    <Transition.Root show={openModal} as={Fragment}>
      <Dialog
        as="div"
        className={`${type === 'file' && expand ? 'absolute bottom-0' : 'relative z-[1000]'} `}
        initialFocus={cancelButtonRef}
        data-testid="modal-root"
        onClose={() => false}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div
            className={`${
              type === 'file' && expand
                ? ''
                : 'fixed inset-0 bg-white/80 bg-opacity-75 transition-opacity'
            }`}
          />
        </Transition.Child>

        <div
          className={`${
            type === 'file' && expand ? '' : 'fixed '
          } inset-0 overflow-y-auto font-montserrat`}>
          <div
            className={`${
              type === 'file' && expand
                ? 'bottom-0 top-0 ml-10'
                : window.outerWidth <= 820 || window.innerWidth <= 820
                ? 'mt-32'
                : 'min-h-full 2xl:-mt-[64px] -mt-[32px]'
            } flex items-end ${
              type === 'file' && expand ? 'justify-start ' : 'justify-center '
            } p-4 text-center sm:items-center sm:p-0 overflow-auto`}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <Dialog.Panel
                className={`${
                  type === 'file'
                    ? expand
                      ? 'w-[425px]'
                      : window.outerWidth <= 820 || window.innerWidth <= 820
                      ? 'w-auto min-w-[584px] max-w-[585px]'
                      : 'w-[60.5%] min-w-[960px]'
                    : type === 'key-traits-cluster'
                    ? 'w-auto'
                    : type === 'share-file'
                    ? '2xl:w-6/12 w-7/12 2xl:mb-20 -mb-16'
                    : type === 'deletion' || type === 'file-updated'
                    ? '2xl:w-[30%] w-[38%]'
                    : '2xl:w-5/12 xl:w-7/12 lg:w-7/12 md:w-8/12'
                } transform overflow-hidden ${
                  type === 'file' && expand
                    ? 'rounded-[15px] absolute bottom-0 mb-8'
                    : 'rounded-[25px] relative'
                } bg-white text-left transition-all shadow-[0_5px_30px_-1px_rgba(0,0,0,0.25)]`}>
                {type === 'file' && !expand && (
                  <>
                    <Tabs>
                      <div className={`${showTabUpload ? 'px-5' : ''} bg-white `}>
                        <div className="flex items-center justify-between">
                          <div className="flex w-full">
                            <TabList className="flex items-center justify-around w-full">
                              <Tab
                                onClick={handleTabUpload}
                                className={`${
                                  showTabUpload ? 'Tab--upload' : 'Tab--upload--reverse'
                                } flex cursor-pointer items-center outline-none`}>
                                <img
                                  src="/icons/computer.svg"
                                  className={`${
                                    showTabUpload
                                      ? window.outerWidth <= 820 || window.innerWidth <= 820
                                        ? '-ml-8 mr-4'
                                        : 'mr-4'
                                      : window.outerWidth <= 820 || window.innerWidth <= 820
                                      ? 'ml-[14%]'
                                      : 'ml-[28%]'
                                  }`}
                                  alt="Computer icon"
                                />
                                <Dialog.Title
                                  as="h3"
                                  className={`${
                                    showTabUpload ? ' ' : 'ml-4'
                                  } text-sm leading-6 text-[#364152] font-semibold`}>
                                  {title}
                                </Dialog.Title>
                              </Tab>

                              <Tab
                                onClick={handleTabSource}
                                className={`${
                                  showTabUpload
                                    ? 'Tab-source'
                                    : window.outerWidth <= 820 || window.innerWidth <= 820
                                    ? 'Tab-source--reverse-mobile'
                                    : 'Tab-source--reverse'
                                } flex cursor-pointer  items-center outline-none`}>
                                <img
                                  src="/icons/source-modal.svg"
                                  className={`${
                                    showTabUpload
                                      ? 'mr-4'
                                      : window.outerWidth <= 820 || window.innerWidth <= 820
                                      ? 'ml-[1%]'
                                      : 'ml-[10%]'
                                  }`}
                                  alt="Source icon"
                                />
                                <Dialog.Title
                                  as="h3"
                                  className={`${
                                    showTabUpload ? '' : 'ml-4'
                                  } text-sm leading-6 text-[#788AA6] font-semibold`}>
                                  Connect to a source
                                </Dialog.Title>
                              </Tab>
                            </TabList>
                          </div>
                          <div
                            className={`${
                              showTabUpload
                                ? window.outerWidth <= 820 || window.innerWidth <= 820
                                  ? 'ml-1'
                                  : ''
                                : 'mr-5'
                            } cursor-pointer flex flex-row items-center gap-0.5`}>
                            {showTabUpload && isFileUploaded && (
                              <img
                                src={`/icons/${expand ? 'expand-upload' : 'minus-upload'}.svg`}
                                className={`${
                                  expand ? 'pr-3' : ' mt-2 pr-3 -ml-[1px]'
                                } cursor-pointer z-[1000] h-[3.5px]`}
                                alt="Expand"
                                onClick={() => {
                                  setExpand(!expand);
                                }}
                              />
                            )}

                            <img
                              src="/icons/cancel.svg"
                              alt="Cancel icon file"
                              className="h-3"
                              onClick={closeIconFile}
                            />
                          </div>
                        </div>

                        <div className="flex justify-center">
                          <div
                            className={`${
                              showTabUpload
                                ? window.outerWidth <= 820 || window.innerWidth <= 820
                                  ? 'h-auto min-h-[315px] px-2'
                                  : 'h-auto min-h-[315px] px-5'
                                : `${
                                    window.innerWidth <= 1360
                                      ? 'h-[340px] min-h-[340px]'
                                      : 'h-[347px] min-h-[347px]'
                                  } mx-10 py-1 pr-5`
                            } ${
                              isFileUploaded || !showTabUpload
                                ? 'rounded-[20px] border-dashed border-2 border-[#E3E8EF]'
                                : ''
                            } mt-5 w-full`}>
                            <TabPanel>
                              {showFileReq ? (
                                <div className="2xl:mx-36 lg:mx-16 mt-2 h-[291px] h-min-[291px] bg-[#C1F4FF1A] flex flex-col">
                                  <span className="text-[#364152] flex justify-center pt-3.5 font-bold text-xl">
                                    File Requirements
                                  </span>
                                  <div
                                    className="flex justify-end mr-5 pb-4 -mt-[18px] cursor-pointer"
                                    onClick={handelCancel}>
                                    <img src="/icons/cancel-steps.svg" alt="Cancel Steps" />
                                  </div>

                                  {/* <CarouselUI /> */}
                                </div>
                              ) : !isFileUploaded ? (
                                <div className="h-full outline-none">
                                  <div className="flex">
                                    <div
                                      className={`${
                                        window.innerWidth <= 1360 ? 'pb-[70px]' : 'pb-12'
                                      } flex flex-row bg-[#2497B21A] mr-6 pt-10 rounded-[20px] justify-center w-6/12`}>
                                      <div
                                        className={`${
                                          window.outerWidth <= 820 || window.innerWidth <= 820
                                            ? 'ml-4'
                                            : ''
                                        }`}></div>
                                      <div
                                        className={`${
                                          window.outerWidth <= 820 || window.innerWidth <= 820
                                            ? 'text-start pl-2.5'
                                            : 'text-center pl-3'
                                        } flex flex-col justify-center`}>
                                        <span
                                          className={`${
                                            window.innerWidth <= 1360 ? 'text-sm' : 'text-sm'
                                          } text-[#364152] font-semibold pb-5`}>
                                          Make sure that your file looks like this:
                                        </span>

                                        <div className={`flex pt-2.5 mr-6 ml-3 pb-10`}>
                                          <img
                                            src="/img/excel-upload.svg"
                                            alt="Excel"
                                            className=""
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex flex-col gap-3 w-6/12 border-[1px] border-[#E3E8EF] border-solid rounded-[20px] py-3.5 px-8">
                                      <div
                                        className={`w-full rounded-[20px] border-dashed border-2 border-[#E3E8EF]`}
                                        {...getRootProps()}>
                                        <div className="mt-8 flex flex-col justify-center text-center mb-7">
                                          <div className="flex flex-row gap-14 items-center justify-center">
                                            <img src="/icons/xlsx-upload.svg" alt="Upload icon" />
                                            <img src="/icons/csv-upload.svg" alt="Upload icon" />
                                            <img src="/icons/sav-upload.svg" alt="Upload icon" />
                                          </div>

                                          <div className="flex flex-row items-center pt-6 gap-1 justify-center">
                                            <span className="font-semibold text-sm text-center">
                                              Drop your file here, or click to
                                            </span>
                                            <span className="text-sm font-normal">
                                              <label className="text-sm text-teal-500 underline decoration-teal-500 hover:text-teal-600 font-semibold cursor-pointer">
                                                browse
                                                {isSafariBrowser && (
                                                  <input
                                                    data-testid="attaching-test"
                                                    id="dropzone-file"
                                                    type="file"
                                                    className="hidden"
                                                    ref={uploadInputRef}
                                                    onClick={handleChooseFile}
                                                    onChange={handleUploadFileClick}
                                                  />
                                                )}
                                              </label>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="flex flex-col gap-2.5 justify-center w-full text-center">
                                        <span className="text-xs font-semibold light-black">
                                          OR
                                        </span>
                                        <div className="flex flex-row gap-2 justify-center pt-1">
                                          <img src="/icons/link-url.svg" alt="Upload icon" />
                                          <span className="text-sm font-semibold light-black">
                                            Link a Google Sheet URL:
                                          </span>
                                        </div>

                                        <div className="flex items-center border border-[#000000] rounded-[10px] overflow-hidden shadow-sm focus-within:shadow">
                                          <input
                                            value={googleSheetUrl}
                                            onChange={(e) => setGoogleSheetUrl(e.target.value)}
                                            className="w-full bg-transparent placeholder:text-[#788AA6] text-sm px-3 py-1.5 focus:outline-none"
                                            placeholder="https://docs.google.com..."
                                          />
                                          <button
                                            className="bg-[#1C8CA6] p-2.5 flex items-center justify-center"
                                            onClick={handleUploadGoogleSheet}>
                                            <img src="/icons/arrow-white.svg" alt="Upload icon" />
                                          </button>
                                        </div>

                                        <span className="text-[11px] text-left ml-4 light-black -mt-2">
                                          <b>Tip:</b> Check that sharing is set to “Anyone with the
                                          link”
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex flex-col justify-center mt-8 outline-none">
                                  {showSheetsScreen ? (
                                    <div className="flex flex-col">
                                      <div className="flex justify-center">
                                        <div className="w-11/12">
                                          {window.outerWidth <= 820 || window.innerWidth <= 820 ? (
                                            <>
                                              <span className="flex justify-center font-semibold text-base text-center underline underline-offset-[16px] decoration-[#DAE0E9]">
                                                Select the worksheet to
                                                analyze&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;
                                              </span>
                                            </>
                                          ) : (
                                            <>
                                              <span className="flex justify-center font-semibold text-base text-center underline underline-offset-[16px] decoration-[#DAE0E9] pl-16">
                                                Select the worksheet to
                                                analyze&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;&#160;
                                              </span>
                                            </>
                                          )}

                                          <div className="flex flex-col items-center justify-center mt-8 pl-14">
                                            <div
                                              className=" overflow-auto"
                                              style={{
                                                maxHeight: 200
                                              }}>
                                              {sheets &&
                                                sheets.length > 0 &&
                                                sheets.map((sheet) => (
                                                  <div
                                                    onClick={() => setSheetSelected(sheet)}
                                                    className={`${
                                                      sheetSelected == sheet
                                                        ? 'font-bold bg-[#C1F4FF33]'
                                                        : ''
                                                    } border-[1px] cursor-pointer hover:bg-[#C1F4FF33]  text-start border-t-0 border-r-0 text-sm border-l-0 border-[#DAE0E9] h-[45px] flex items-center ${
                                                      window.outerWidth <= 820 ||
                                                      window.innerWidth <= 820
                                                        ? 'w-[300px] pl-3'
                                                        : 'w-[520px] pl-10'
                                                    }`}>
                                                    {sheet}
                                                  </div>
                                                ))}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="w-1/12 invisible">test</div>
                                      </div>
                                    </div>
                                  ) : showUpgradePlan ? (
                                    <>
                                      <div className="flex flex-col pt-7 justify-center">
                                        <span className="text-[#364152] text-xl font-bold">
                                          Ooops! This file has more than 500 rows
                                        </span>
                                        <UpgradePlanText classname={'pt-12 justify-center'} />
                                      </div>
                                    </>
                                  ) : (
                                    <div className="pt-2">
                                      {(sheetSelected && sheetSelected.length > 0) || isCSVFile ? (
                                        <div
                                          className={`${
                                            window.outerWidth <= 820 || window.innerWidth <= 820
                                              ? 'px-1.5'
                                              : 'px-24'
                                          }`}>
                                          <UploadStepsSpinningWheel />
                                        </div>
                                      ) : (
                                        <LoaderBubble />
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </TabPanel>
                            <TabPanel
                              className={`${
                                window.outerWidth <= 820 || window.innerWidth <= 820
                                  ? 'pl-4'
                                  : '2xl:pl-14 pl-7'
                              } overflow-y-auto h-full`}>
                              <span
                                className={`${
                                  window.innerWidth <= 1360 ? 'text-sm' : 'text-base'
                                } text-[#000000] font-semibold flex justify-start pb-5 2xl:pl-[6.25rem] pl-[2.25rem] pt-4`}>
                                Standard Connectors:
                              </span>
                              <div
                                className={`${
                                  accountPaid ||
                                  starterAccount ||
                                  accountLillyPaid ||
                                  trialAccountPaid ||
                                  newLillyClaim
                                    ? ''
                                    : 'pointer-events-none'
                                } grid grid-cols-5 ${
                                  window.outerWidth <= 820 || window.innerWidth <= 820
                                    ? 'px-4 gap-5'
                                    : 'px-[32px] 2xl:px-24 gap-8'
                                }`}>
                                <>
                                  {standartConnectors.slice(0, 4).map((connector: any) => {
                                    return (
                                      <Connector
                                        key={connector.icon}
                                        connector={connector}
                                        handleClickConnector={handleClickConnector}
                                      />
                                    );
                                  })}
                                </>
                              </div>

                              <span
                                className={`${
                                  window.innerWidth <= 1360 ? 'text-sm' : 'text-base'
                                } text-[#000000] font-semibold flex justify-start pb-5 2xl:pl-[6.25rem] pl-[2.25rem] pt-9`}>
                                Premium Connectors:
                              </span>
                              <div
                                className={`${
                                  accountPaid ||
                                  starterAccount ||
                                  accountLillyPaid ||
                                  trialAccountPaid ||
                                  newLillyClaim
                                    ? ''
                                    : 'pointer-events-none'
                                } grid grid-cols-5 ${
                                  window.outerWidth <= 820 || window.innerWidth <= 820
                                    ? 'px-4 gap-5'
                                    : 'px-[32px] 2xl:px-24 gap-8'
                                }`}>
                                <>
                                  {standartConnectors.slice(4, 1000).map((connector: any) => {
                                    return (
                                      <Connector
                                        key={connector.icon}
                                        connector={connector}
                                        handleClickConnector={handleClickConnector}
                                      />
                                    );
                                  })}
                                </>
                              </div>

                              <div
                                className={`pt-10 flex flex-col gap-4 justify-start w-full pb-[15rem] 2xl:pl-[6.25rem] pl-[2.25rem]`}>
                                <span
                                  className={`${
                                    window.innerWidth <= 1360 ? 'text-sm' : 'text-base'
                                  } text-[#000000] font-bold`}>
                                  Search 600+ available connectors
                                </span>
                                <div>
                                  <div className="flex flex-row items-center">
                                    <input
                                      value={connectorSearch}
                                      type="text"
                                      className={`${
                                        accountPaid ||
                                        starterAccount ||
                                        accountLillyPaid ||
                                        trialAccountPaid ||
                                        newLillyClaim
                                          ? ''
                                          : 'pointer-events-none'
                                      } w-[522px] h-[45px] rounded-[10px] border border-black px-4 -mt-2 pb-2 bg-gray-50 focus:ring-black  outline-none focus:outline-none focus:ring-0 focus:border-black`}
                                      onChange={handleInputConnector}
                                      onKeyDown={handleKeyDownConnector}
                                    />
                                    <Button
                                      textColor="#E7811D"
                                      description="Add"
                                      icon="add-orange.svg"
                                      backgroundColor="#fff"
                                      fontSize={12}
                                      fontWeight={600}
                                      heigh={35}
                                      border={50}
                                      className="ml-6 px-7"
                                      borderColor="#E7811D"
                                      borderSize="2px"
                                      isDisabled={!getValidateConnectorText()}
                                      handleClick={addConnectorsToList}
                                    />
                                  </div>

                                  {showConnectorDropDown && connectorsFiltered.length > 0 && (
                                    <div className="z-[1000] mt-0.5  border border-black mx-3 max-h-[200px] overflow-y-auto w-[499px]">
                                      {connectorsFiltered.map((option, index) => (
                                        <div
                                          key={index}
                                          className="px-4 py-1.5 cursor-pointer hover:bg-gray-100 text-sm"
                                          onMouseDown={() => {
                                            setConnectorSearch(option);
                                            setShowConnectorDropDown(false);
                                          }}>
                                          {option}
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                  {connectorsList.length > 0 &&
                                    (!showConnectorDropDown || connectorsFiltered?.length == 0) && (
                                      <div
                                        className={`mt-auto mb-2.5 flex flex-wrap flexContainer mx-2.5 gap-x-4 gap-y-2.5 w-full max-w-[522px] pt-2.5`}
                                        id="contenedor">
                                        {connectorsList.map((option, index) => (
                                          <div
                                            className={`border-solid rounded-[25px] w-auto px-2.5 border-[1px] h-auto border-[#364152] bg-[#fff] -mb-0.5 min-h-[26px]`}>
                                            <div className="flex justify-between items-baseline mt-1.5 mb-1.5 mx-2.5 w-full">
                                              <span className="font-semibold text-[#364152]">
                                                {option}
                                              </span>
                                              <img
                                                src="/icons/cancel-connectors.svg"
                                                alt="Text Type"
                                                className="mr-3 cursor-pointer"
                                                onClick={() => handleRemoveConnector(option)}
                                              />
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                </div>
                              </div>
                            </TabPanel>
                          </div>
                        </div>
                      </div>
                    </Tabs>
                    <div
                      className={`${
                        showTabUpload ? '' : '  -mb-1'
                      } py-4 mb-1 flex items-center px-10`}>
                      <div
                        className={`${
                          showTabUpload ? 'justify-end' : 'justify-center'
                        } w-full flex flex-row flex-1`}>
                        {showTabUpload ? (
                          showSheetsScreen && (
                            <div className="flex justify-end cursor-pointer mr-8">
                              <Button
                                textColor={'#fff'}
                                description={'Continue'}
                                backgroundColor={'#fd8f22'}
                                fontSize={14}
                                fontWeight={600}
                                heigh={34}
                                border={50}
                                width={152}
                                handleClick={() => setDoneSheetsScreen(true)}
                                isDisabled={sheetSelected?.length == 0}
                              />
                            </div>
                          )
                        ) : (
                          <>
                            {!accountPaid &&
                              !starterAccount &&
                              !accountLillyPaid &&
                              !trialAccountPaid &&
                              !newLillyClaim && (
                                <UpgradePlanText
                                  handleClickUpgrade={handleClickUpgrade}
                                  classname={'w-8/12 flex justify-end'}
                                  fromConnectors={true}
                                />
                              )}
                            <div
                              className={`${
                                accountPaid ||
                                starterAccount ||
                                accountLillyPaid ||
                                trialAccountPaid ||
                                newLillyClaim
                                  ? 'w-full'
                                  : ' w-4/12'
                              } -mt-1 flex justify-end`}>
                              <Button
                                textColor="#fff"
                                description="Request connection"
                                backgroundColor="#fd8f22"
                                fontSize={14}
                                fontWeight={600}
                                heigh={40}
                                border={50}
                                handleClick={handleClickReqConnection}
                                className="px-6"
                                isDisabled={enableReqConnection}
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                )}

                {type === 'file' && expand && (
                  <>
                    <Tabs>
                      <div className={`${showTabUpload ? 'px-5' : ''} bg-white `}>
                        <div className="flex items-center justify-between h-[66px]">
                          <div className="flex w-full ml-6">
                            <TabList className="flex items-center justify-start w-full">
                              <Tab className={`flex items-center outline-none`}>
                                <Dialog.Title as="h3">
                                  <span className="text-sm text-[#364152] font-semibold ml-3">
                                    File upload in progress...
                                  </span>
                                </Dialog.Title>
                              </Tab>
                            </TabList>
                          </div>
                          <div
                            className={` cursor-pointer flex flex-row items-center gap-0.5 mr-5`}>
                            {showTabUpload && isFileUploaded && (
                              <img
                                src={`/icons/${expand ? 'expand-upload' : 'minus-upload'}.svg`}
                                className={`${
                                  expand ? 'pr-3' : ' mt-2 pr-3 -ml-[1px]'
                                } cursor-pointer z-[1000] h-3`}
                                alt="Expand"
                                onClick={() => {
                                  setExpand(!expand);
                                }}
                              />
                            )}

                            <img
                              src="/icons/cancel.svg"
                              alt="Cancel icon file"
                              className="h-3"
                              onClick={closeIconFile}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="invisible h-0">
                        <UploadStepsSpinningWheel />
                      </div>
                    </Tabs>
                  </>
                )}

                {type !== '' &&
                  type !== 'file' &&
                  type !== 'key-traits-cluster' &&
                  type !== 'excludeGroup' &&
                  type !== 'share-file' &&
                  type !== 'empty' &&
                  type !== 'file-updated' && (
                    <>
                      <div className="bg-white pt-5 mb-8">
                        <div className="flex justify-between mt-6">
                          <div className="flex items-center ml-[32px] lg:ml-[47px]">
                            {type === 'deletion' && (
                              <img
                                src="/icons/delete.svg"
                                className="mr-6 -mt-14"
                                alt="Delete icon"
                              />
                            )}
                            <div className={`${type !== 'deletion' && 'ml-8'} flex flex-col`}>
                              <div
                                className={`${
                                  type === 'deletion' ? 'truncate max-w-lg' : ''
                                } text-xl leading-6 text-[#364152] font-bold`}>
                                {title}
                              </div>
                              <span className="text-sm mb-[22px] mt-3">
                                {type === 'deletion'
                                  ? 'This action cannot be undone.'
                                  : 'Do you want to save your work before moving on?'}
                              </span>
                            </div>
                          </div>
                          <div className="cursor-pointer mr-[31px] -mt-3">
                            {!deleteFile && (
                              <img src="/icons/cancel.svg" alt="Cancel icon" onClick={closeIcon} />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="py-2 items-center bg-neutral-100/50 border-t-[1px]">
                        <div className="flex justify-end mt-3 mb-3 mr-8">
                          {type === 'deletion' ? (
                            <>
                              <Button
                                textColor="#364152"
                                description="Cancel"
                                backgroundColor="#fff"
                                fontSize={14}
                                fontWeight={600}
                                heigh={35}
                                border={50}
                                handleClick={closeIcon}
                                className="outline-none mr-[24px] px-6"
                                borderColor="#364152"
                              />

                              <Button
                                textColor={`${deleteFile || isDeletingView ? '#364152' : '#fff'}`}
                                description={`${
                                  deleteFile || isDeletingView ? 'Deleting...' : 'Delete'
                                }`}
                                backgroundColor={`${deleteFile || isDeletingView ? '' : '#E34653'}`}
                                fontSize={14}
                                fontWeight={600}
                                heigh={35}
                                border={50}
                                isDisabled={deleteFile || isDeletingView}
                                // width={181}
                                handleClick={handleDeletion}
                                className="outline-none px-7"
                                borderColor={`${
                                  deleteFile || isDeletingView
                                    ? 'rgba(54, 65, 82, 0.25)'
                                    : '#D23845'
                                }`}
                              />
                            </>
                          ) : (
                            <>
                              <Button
                                textColor="#364152"
                                description="Cancel"
                                backgroundColor="#fff"
                                fontSize={14}
                                fontWeight={600}
                                heigh={34}
                                border={50}
                                width={130}
                                handleClick={closeIcon}
                                className="outline-none mr-6"
                                borderColor="rgba(54, 65, 82, 0.25)"
                              />

                              <Button
                                textColor="#fff"
                                description="Confirm"
                                backgroundColor="#D23845"
                                fontSize={14}
                                fontWeight={600}
                                heigh={34}
                                border={50}
                                width={150}
                                handleClick={handleConfirm}
                                className="outline-none"
                                borderColor="#D23845"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                {type === 'file-updated' && (
                  <>
                    <div className="bg-white pt-5 mb-16">
                      <div className="flex justify-between mt-3">
                        <div className="flex items-center ml-[36px]">
                          <div className={`ml-8'} flex flex-col`}>
                            <div className={`text-xl leading-6 text-[#364152] font-bold pb-3`}>
                              View Not Available
                            </div>
                            <span className="text-sm mb-[22px] mt-3">
                              <p>Settings for this file have been updated and some of </p>
                              <p> the elements of this view are no longer valid.</p>
                            </span>
                          </div>
                        </div>
                        <div className="cursor-pointer mr-[31px] -mt-3">
                          {!deleteFile && (
                            <img
                              src="/icons/cancel.svg"
                              alt="Cancel icon"
                              onClick={closeViewDisplayFileChanges}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    {/* 
                    <div className="py-2 items-center bg-neutral-100/50 border-t-[1px]">
                      <div className="flex justify-end mt-3 mb-3 mr-8">
                        <>
                          <Button
                            textColor="#364152"
                            description="Cancel"
                            backgroundColor="#fff"
                            fontSize={14}
                            fontWeight={600}
                            heigh={35}
                            border={50}
                            handleClick={closeViewDisplayFileChanges}
                            className="outline-none mr-6 px-6"
                            borderColor="#364152"
                          />

                          <Button
                            textColor="#fff"
                            description="Go Anyway"
                            backgroundColor="#2497B2"
                            fontSize={14}
                            fontWeight={600}
                            heigh={35}
                            border={50}
                            handleClick={handleGoAnyWay}
                            className="outline-none px-7"
                            borderColor="#1C8CA6"
                          />
                        </>
                      </div>
                    </div> */}
                  </>
                )}

                {type === 'key-traits-cluster' && (
                  <>
                    <div className="bg-white pt-5">
                      <div className="flex justify-between mt-2">
                        <div className="flex items-center ml-14">
                          <span className="text-[#364152] font-bold text-xl">{title}</span>&nbsp;
                          <span className="text-[#364152] text-xl">Detailed View</span>
                        </div>
                        <div className="cursor-pointer mr-[31px]">
                          <img src="/icons/cancel.svg" alt="Cancel icon" onClick={closeIcon} />
                        </div>
                      </div>
                    </div>
                    <div className="mx-[72px] mb-9">
                      <Echart
                        optionData={optionChart}
                        heigth={optionChart?.yAxis?.data?.length > 8 ? 0 : 230}
                        width={800}
                      />
                    </div>
                    <div className="py-2 items-center bg-neutral-100/50 border-t-[1px]">
                      <div className="flex justify-end mt-3 mb-3 mr-8">
                        <Button
                          textColor="#fff"
                          description="Close"
                          backgroundColor="#E34653"
                          fontSize={14}
                          fontWeight={600}
                          heigh={34}
                          border={50}
                          width={181}
                          handleClick={closeIcon}
                          className="outline-none"
                          borderColor="#D23845"
                        />
                      </div>
                    </div>
                  </>
                )}

                {type === 'excludeGroup' && (
                  <>
                    <div className="bg-white pt-5 flex flex-col ml-14 gap-2">
                      <div className="flex justify-between mt-2">
                        <div className="flex items-center">
                          <span className="text-[#364152] font-bold text-xl">{title}</span>
                        </div>
                        <div className="cursor-pointer mr-[31px]">
                          <img src="/icons/cancel.svg" alt="Cancel icon" onClick={closeIcon} />
                        </div>
                      </div>
                      <div className="mb-[52px]">
                        <span className="text-[#364152] text-sm">
                          Please set up these rows as ‘Include’ or move the excluded rows out of the
                          group
                        </span>
                      </div>
                    </div>
                  </>
                )}

                {type === 'share-file' && (
                  <>
                    <div className="bg-white pt-5 flex flex-col gap-2 divide-y-[1px]">
                      <div className="flex justify-between mt-2 mb-2 ml-8">
                        <div className="flex items-center gap-4">
                          <img src="/icons/share-modal.svg" alt="Share icon" />
                          <span className="text-[#364152] text-sm font-semibold">
                            {' '}
                            {`${from === 'myviews' ? 'View' : 'File'} Sharing`}{' '}
                          </span>
                        </div>
                        <div className="cursor-pointer mr-6">
                          <img src="/icons/cancel.svg" alt="Cancel icon" onClick={closeIcon} />
                        </div>
                      </div>
                      <div className="mb-[52px]">
                        <div className="flex flex-col">
                          {!shareFileLoader ? (
                            <>
                              <div className="ml-12 flex flex-col gap-4 mt-5">
                                <span className="text-[#364152] font-bold text-[20px] mb-0.5">
                                  {`Who do you want to share ${
                                    from === 'myviews' ? 'this view' : 'the file'
                                  } with?`}
                                </span>
                                <div className="flex">
                                  <div className="flex flex-col gap-2 w-full">
                                    <div className="flex justify-between items-center gap-3">
                                      <input
                                        data-testid="email-input"
                                        type="text"
                                        value={email}
                                        onChange={(e) =>
                                          setEmail(e.target.value.toLocaleLowerCase())
                                        }
                                        className="border w-full text-sm placeholder:pl-5 placeholder:font-montserrat placeholder:text-[#788AA6CC] placeholder:text-sm placeholder:italic placeholder:font-semibold border-[#2497B2] rounded-[5px] p-2 focus:outline-none focus:ring-0 focus:border-[#2497B2]"
                                        placeholder="Enter one or more (comma separated) email address(es)"
                                      />
                                      <Button
                                        data-testid="add-email-button"
                                        textColor="#fff"
                                        description="Add"
                                        icon="plus.svg"
                                        backgroundColor="#FD8F22"
                                        fontSize={14}
                                        fontWeight={600}
                                        heigh={30}
                                        border={50}
                                        width={126}
                                        handleClick={addEmails}
                                        className="outline-none mr-12"
                                        borderColor="#E7811D"
                                      />
                                    </div>

                                    <div className="flex items-center pt-2 ml-8">
                                      <input
                                        checked={notificationChecked}
                                        id="notification"
                                        onChange={() =>
                                          setNotificationChecked(!notificationChecked)
                                        }
                                        type="checkbox"
                                        value=""
                                        className="w-5 h-5 text-[#FD8F22] checkbox cursor-pointer"
                                        style={{
                                          border: notificationChecked
                                            ? '1px solid #E7811D'
                                            : '1px solid #788AA6'
                                        }}
                                      />
                                      <label className={`ml-2 text-sm cursor-pointer`}>
                                        Send notification email
                                      </label>
                                    </div>

                                    <div className="ml-20 pr-4 w-[70%] mt-5 h-[122px] overflow-auto -mb-6">
                                      <div className="grid grid-cols-1 divide-y-[1px]">
                                        {emails &&
                                          emails?.length > 0 &&
                                          emails?.map((value: any, index: number) => {
                                            return (
                                              <>
                                                <div className="flex justify-between items-center hover:bg-light-blue">
                                                  <div className="flex items-center">
                                                    {emailsSharedCollection &&
                                                      emailsSharedCollection.find(
                                                        (email) => email == value
                                                      ) && (
                                                        <div>
                                                          <img
                                                            src="/icons/tick-sharing.svg"
                                                            alt="Cross"
                                                            className="cursor-pointer"
                                                          />
                                                        </div>
                                                      )}

                                                    <span
                                                      className={`${
                                                        emailsSharedCollection &&
                                                        emailsSharedCollection.find(
                                                          (email) => email == value
                                                        )
                                                          ? 'pl-2.5'
                                                          : 'pl-[30px]'
                                                      } text-[#364152] font-semibold text-sm  py-1.5 line-clamp-1`}
                                                      data-testid={`emails-list-${index}`}>
                                                      {value}
                                                    </span>
                                                  </div>

                                                  <img
                                                    src="/icons/cancel-360.svg"
                                                    alt="Cross"
                                                    className="cursor-pointer mr-3"
                                                    onClick={() => handleRemoveSingleValue(value)}
                                                  />
                                                </div>
                                                {index === emails?.length - 1 && (
                                                  <div className="pl-0"></div>
                                                )}
                                              </>
                                            );
                                          })}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="pt-[5.25rem] pb-10">
                                <Loader showText={false} />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      <div>
                        <div className="py-4 flex justify-end mr-6">
                          <Button
                            textColor="#364152"
                            description="Cancel"
                            backgroundColor="#fff"
                            fontSize={14}
                            fontWeight={600}
                            heigh={40}
                            border={50}
                            handleClick={closeIcon}
                            className="outline-none mr-[24px] px-[33px]"
                            borderColor="#364152"
                            isDisabled={saveChangesOff}
                          />

                          <Button
                            textColor="#fff"
                            description="Save Changes"
                            backgroundColor="#2497B2"
                            fontSize={14}
                            fontWeight={600}
                            heigh={40}
                            border={50}
                            handleClick={handleClickSaveChanges}
                            className="outline-none px-6"
                            borderColor="#2497B2"
                            isDisabled={saveChangesOff || shareFileLoader}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
